var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [
            { icon: "tachometer-alt", page: _vm.page_title.toUpperCase() },
          ],
        },
      }),
      _c("v-container", { attrs: { fluid: "" } }, [_c("ComingSoon")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }